<template>
  <div class="InMail">
    <div v-loading="loading"></div>
    <div class="InMails flex">
      <div class="InMailList" v-infinite-scroll="load">
        <div class="InMail-Info flex2">
          <div>
            <img v-if="Infos.pictureUrl" :src="Infos.pictureUrl" class="Info-img">
            <img v-else src="@/assets/PC/shop/shop-InfoHead.jpg" class="Info-img">
          </div>
          <div style="width: 100%; overflow: hidden">
            <h2 class="co-fff hidden">{{Infos.name}}</h2>
          </div>
        </div>
        <div class="InMail-search">
          <el-input v-model="msgs.title" @keyup.enter.native="Search" class="InMail-search-inp" placeholder="搜索通知"></el-input>
          <i class="el-icon-search cur" @click="Search"></i>
        </div>
        <div v-if="!Isdata" class="InMail-msg-list">
          <div v-for="item in msgList.data" :key="item.id" class="InMail-msg-item flex cur" @click="goInMallDetail(item.id, item.forumQuestionId, item.type)" :class="DetailId == item.id ? 'InMail-msg-item-active':''">
            <div class="InMail-msg-item-icon flex1">
              <img src="@/assets/PC/home/znx.png">
            </div>
            <div class="InMail-msg-item-d"> 
              <div class="flex3" style="width: 100%">
                <span v-if="item.type == 0" class=" co-fff">系统通知</span>
                <span v-if="item.type == 1" class=" co-fff">提问对话</span>
                <span v-if="item.type == 3" class=" co-fff">合作伙伴审核通过</span>
                <span v-if="item.type == 4" class=" co-fff">合作伙伴审核拒绝</span>
                <span class="InMail-msg-item-deta">{{ item.dateTimeString }}</span>
              </div>
              <div class="flex3" style="width: 100%">
                <span class="InMail-msg-item-title">{{ item.introduction }}</span>
                <div v-if="!item.isReaded" class="box-msg"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="Isdata" style="height: 90px" class="flex1 co-7E3">暂无消息</div>
      </div>
      <div v-if="clientWidth > 768" class="InMailList-d">
        <div v-if="IsDetail" class="InMailList-d-s">
          <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 0">系统通知</div>
          <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 1">提问对话</div>
          <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 3">合作伙伴审核通过</div>
          <div class="InMailList-d-s-title" v-if="ChatList.length > 0 && ChatList[0].type == 4">合作伙伴审核拒绝</div>
          <div class="chat-box" ref="chatBox">
            <div class="chat-item" v-for="item in ChatList" :key="item.id" :class="!item.isMy ? 'chat-item-left' : 'chat-item-right'">
              <div class="InMailList-d-s-deta co-999 tc">{{item.dataTimeString}}</div>
              <div class="InMailList-d-s-content flex">
                <div class="InMailList-d-s-content-icon flex1" v-if="!item.isMy"><img src="@/assets/PC/home/znx.png"></div>
                <div class="InMailList-d-s-content-icon flex1" v-else><img src="@/assets/PC/header/user_slices/user1.png"></div>
                <div class="InMailList-d-s-content-text">
                  <b v-if="item.type != 1">亲爱的{{ Info.name }}，你好：</b> 
                  <p :class="item.type != 1 ? 'p-top' : ''" v-html="item.content"></p> 
                  <div class="san0" v-if="!item.isMy"></div>
                  <div class="san1" v-else></div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-input" v-if="IsChat">
            <el-input v-model="params.content" @keyup.enter.native="handleSend" class="chat-input-inp" placeholder="输入内容"></el-input>
            <div class="chat-btn" @click="handleSend">发送</div>
          </div>
        </div>
        <div v-else class="co-999 flex1" style="height: 100%">您还未选中通知，点击左侧查看通知</div>
      </div>
    </div>
  </div>  
</template>

<script>
import { GetSystemMessage, GetSystemMessageInfo, GetUserInfo, GetSystemMessageTop4, Question} from "@/api/profile.js";
import { debounce } from "@/utils/common";
import { dataState } from "@/api/all.js";

export default {
  name: "InMail",
  data() {
    return {
      loading: true,                          // !loading
      loadings: true,
      sendLoading: false,
      Info: this.$store.state.Infos,          // !个人信息
      msgs:{
        page: 1,
        limit: 10,
        title: '',
        messageId: ''
      },
      msgList: {data: [], recordCount: 0 },   // !消息列表
      ChatList: [],                       // !详情数据
      IsDetail: false,                        // !是否展开详情
      DetailId: '',                           // !当前选中id
      Isdata: false,                          // !暂无消息
      IsloadList: false,                      // !下拉加载
      IsChat: false,                          // !是否对话
      params: {
        content: '',
        forumQuestionId: ''
      }
    }
  },
  mounted() {
    if(!this.$store.state.token) {
      this.$router.push('/');
    }else {
      if(sessionStorage.getItem('msgs')){
        this.msgs = JSON.parse(sessionStorage.getItem('msgs'));
      }
      this.GetInit();
    }
    
    // !数据统计 - 页面访问日志
    this.recordVisitLog(1, "InMail", "");
  },
  methods: {
    // !记录访问日志
    recordVisitLog(visitType, pageUrl, relationId) {
      try {
        const visitLogData = {
          visitType: visitType,
          gid: sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
          url: window.location.href,
          pageUrl: pageUrl,
          relationId: relationId || ""
        };
        dataState(visitLogData).then(res => {
          if (res && res.data) {
            sessionStorage.setItem('gid', res.data);
          }
        }).catch(err => {
          console.error('访问日志记录失败:', err);
        });
      } catch (error) {
        console.error('访问日志记录异常:', error);
      }
    },
    // !初始化列表
    GetInit(isTrue) {
      this.msgs.messageId = this.$route.query.id || '';
      GetSystemMessage(this.msgs).then(res => {
        if(res.status == 1) {
          if(isTrue) {
            this.msgList.data = res.data;
            isTrue = false;
          }else {
            this.msgList.data =this.msgList.data.concat(res.data);
          }
          if(this.msgs.messageId && res.data.length > 0){
            this.params.forumQuestionId = res.data[0].forumQuestionId;
          }
          
          if(this.msgList.data.length == res.recordCount) {
            this.IsloadList = false;
          } else {
            this.IsloadList = true;
          }
          if(this.msgList.data.length > 0) {
            this.Isdata = false;
          }else {
            this.Isdata = true;
          }
        } else {
          console.error('获取消息列表失败:', res.message);
          this.$toast(res.message || '获取消息列表失败');
        }
      }).catch(err => {
        console.error('获取消息列表异常:', err);
        this.$toast('获取消息列表失败，请稍后重试');
        this.loading = false;
      }).then(()=> {
        if(this.$route.query.id) {
          if(this.clientWidth > 768) {
            this.DetailId = this.$route.query.id;
            this.GetInitId(this.DetailId)
          }
        }
      })
      this.loading = false;
    },
    load() {
      debounce(()=> {
        if(this.IsloadList) {
        this.msgs.page++;
        this.GetInit();
      }
      },1000)
      
    },
    // !搜索
    Search() {
      // 记录搜索日志
      this.recordVisitLog(2, "InMailSearch", this.msgs.title || "");
      this.msgs.page = 1;
      this.GetInit(true);
    },
    // !查看消息详情
    goInMallDetail(id, forumQuestionId, type = 0) {
      // 记录查看详情日志
      this.recordVisitLog(2, "InMailDetail", id);
      
      let iIndex = '';
      this.msgList.data.filter( (v, i) => {
        if(v.id == id) {
          iIndex = i;
        }
        return iIndex;
      })
      this.msgList.data[iIndex].isReaded = true;
      this.params.forumQuestionId = forumQuestionId;

      if(this.clientWidth > 768) {
        this.$router.push('/Home/InMail?id=' + id);
      } else if(this.clientWidth < 751){
        this.$router.push('/Home/InMailDetail?id=' + id + '&forumQuestionId=' + (type == 1 ? forumQuestionId : ''));
      }
    },
    // !获取详情
    GetInitId(id) {
      this.DetailId = id;
      const Id = {messageId: id};
      GetSystemMessageInfo(Id).then(res => {
        if(res.status == 1) {
          this.ChatList = res.data;
          this.IsDetail = true;
          if(res.data.length > 0 && res.data[0].type == 1){
            this.IsChat = true;
            this.$nextTick(()=> {
              if(this.$refs.chatBox) {
                this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight;
              }
            })
          }
        } else {
          this.$toast(res.message);
          console.error('获取消息详情失败:', res.message);
        }
      }).catch(err => {
        console.error('获取消息详情异常:', err);
        this.$toast('获取消息详情失败，请稍后重试');
      }).then(()=> {
        GetUserInfo().then(res => {// !获取个人信息
          this.$store.dispatch('Profile', res.data);
        }).catch(err => {
          console.error('获取个人信息失败:', err);
        });
        GetSystemMessageTop4().then(res => {
          if(res.status == 1) {
            this.$store.dispatch('MsgTop4', res.data);
          }
        }).catch(err => {
          console.error('获取顶部消息失败:', err);
        });

        this.msgList.data.filter((v, i) => {
          if(v.id == this.$route.query.id){
            this.msgList.data[i].isReaded = true;
          }
          return this.msgList.data;
        })
      })
    },
    // !发送消息
    handleSend() {
      if(this.sendLoading) return;
      if(!this.params.content) {
        this.$toast('请输入内容');
        return;
      }
      // 记录发送消息日志
      this.recordVisitLog(2, "InMailSend", this.params.forumQuestionId || "");
      
      this.sendLoading = true;
      Question(this.params).then(res => {
        this.sendLoading = false;
        if(res.status == 1) {
          this.$toast('发送成功');
          this.ChatList.push({
            id: '',
            dataTimeString: new Date().toLocaleString(),
            content: this.params.content,
            isMy: true,
            type: 1
          });
          this.$nextTick(()=> {
            this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight;
          })
          this.params.content = '';
        } else {
          // 记录发送失败日志
          console.error('发送消息失败:', res.message);
        }
      }).catch(err => {
        this.sendLoading = false;
        console.error('发送消息异常:', err);
      })
    }
  },
  computed: {
    clientWidth () {
      return this.$store.state.clientWidth;
    },
    Infos() {
      return this.$store.state.Infos;
    },
  },
  watch: {
    $route: {
      handler(val) {
        if(val.query.id) {
          this.GetInitId(val.query.id);
        }
      },
      deep: true,
    },
    Infos(val) {
      this.Info = val;
    },
  }
}
</script>

<style lang="scss">
  $mobil_base: 750;

  @function vw($true) {
    @return ($true / $mobil_base) * 100vw;
  }

  .InMail {
    .InMail-msg-item-d {width: 100%;}
    .InMails { width: 1200px; height: 600px; background: #fff; box-shadow: 0 0 15px #ccc; margin: 40px auto; border-radius: 5px; overflow: hidden;}
    .InMailList { width: 333px; height: 600px; background: #3D1152; overflow: auto;}

    .InMailList-d { width: 100%;}
    .InMailList-d-s { padding: 40px; height: 100%;}
    .InMailList-d-s-title { font-size: 18px; padding-bottom: 20px; border-bottom: 1px #7E3D9D solid; margin-bottom: 20px;}
    .InMailList-d-s-deta { font-size: 12px; margin-bottom: 21px; width: 100%; text-align: center;}
    .InMailList-d-s-content-text { padding: 15px; background: #F2F5F7; margin-left: 30px; border-radius: 5px; position: relative;}
    .san0 {width: 0;height: 0;border-top: 7px solid transparent;border-right: 15px solid #F2F5F7;border-bottom: 7px solid transparent; position: absolute; left: -14px; top: 15px;}
    .san1 {width: 0;height: 0;border-top: 7px solid transparent;border-left: 15px solid #F2F5F7;border-bottom: 7px solid transparent; position: absolute; right: -14px; top: 15px;}
    .InMailList-d-s-content-text b {font-size: 18px; }
    .InMailList-d-s-content-text .p-top { margin-top: 5px; }
    .chat-box {padding: 20px; height: 420px; overflow: auto;}
    .chat-item {margin-bottom: 20px; display: flex; align-items: center; flex-direction: column;}
    .chat-item-left {align-items: flex-start;}
    .chat-item-right {align-items: flex-end;}
    .chat-item-right .InMailList-d-s-content .InMailList-d-s-content-icon {order: 1;}
    .chat-item-right .InMailList-d-s-content .InMailList-d-s-content-text {margin-left: 0; margin-right: 30px;}
    .chat-input {position: relative; width: 100%; display: flex; align-items: center; justify-content: center;}
    .chat-input-inp {width: 100%; height: 40px; border-radius: 20px; border: 0; padding-left: 20px; padding-right: 80px; color: #fff;}
    .chat-input .chat-btn {background: #7E3D9D; color: #fff; width: 60px; height: 40px; border-radius: 5px; text-align: center; line-height: 40px; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;}

    .InMail-Info, .InMail-search {padding: 16px; position: relative;}
    .InMail-search, .InMail-msg-item-active { background: #340d49;}
    .InMail-search i {color: #A872C1;position: absolute; left: 30px; top: 23px;}
    .Info-img { width: 62.4px; height: 62.4px; border-radius: 31.2px; margin-right: 8px;}

    .InMail-msg-item {padding: 13px 16px;border-bottom: 1px rgb(36, 35, 35) solid;}
    .InMail-msg-item-icon, .InMailList-d-s-content-icon {min-width: 43px; width: 43px; height: 43px; background: #F2F5F7; border-radius: 50%; margin-right: 10px;}
    .InMail-msg-item-icon img, .InMailList-d-s-content-icon img {width: 20px;}

    .InMail-msg-item-deta, .InMail-msg-item-title, .co-7E3 {color: #7E3D9D;}
    
    .InMailList-d-s-content-text {
      .rich-box {
        max-width: 400px;
        border: 1px #3C1A52 solid;
        border-radius: 6px;
        padding: 6px;
        .rich-img {
          width: auto;
          height: 40px;
          object-fit: contain;
        }
        .rich-title, .rich-title-en {
          font-size: 15px;
          line-height: 1.5;
          color: #000;
          font-weight: bold;
          margin-bottom: 2px;
        }
        .rich-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .rich-left {
          font-size: 12px;
          line-height: 1.5;
          color: #000;
          width: calc( 100% - 110px );
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .rich-right {
          width: 100px;
          height: auto;
          object-fit: contain;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .InMail {
      .InMails, .InMailList{width: 100%;}
      .InMailList {height: calc( 100vh - 13.3333vw);}
      .InMails {margin: 0;height: calc( 100vh - 13.3333vw); border-radius: 0;}

      .InMail-Info {padding: vw(40);}
      .InMail-search {padding: vw(16) vw(40);}
      .Info-img {width: vw(120); height: vw(120);}
      .InMail-search i {font-size: vw(29); left: vw(80); top: vw(39);}

      .InMail-msg-item {padding: vw(40);}
      .InMail-msg-item-icon {width: vw(64); min-width: vw(64); height: vw(64);}
      .InMail-msg-item-icon img {width: vw(37);}

      .InMail-msg-item-title {font-size: vw(24); margin-top: vw(5);}
    }
  }
</style>

<style lang="scss">
  $mobil_base: 750;

  @function vw($true) {
    @return ($true / $mobil_base) * 100vw;
  }
  .InMailList::-webkit-scrollbar {width: 5px;}
  .InMailList::-webkit-scrollbar-track {-webkit-border-radius: 2em;-moz-border-radius: 2em;border-radius:2em}
  .InMailList::-webkit-scrollbar-thumb {background-color:#4d1965;-webkit-border-radius: 2em;-moz-border-radius: 2em;border-radius:2em}
  @media (min-width: 751px) {
    .InMail-search-inp input {height: 28px; border-radius: 14px; background: #4d1965; border: 0; padding-left: 40px; color: #fff;}
  }
  @media (max-width: 768px) {
    .InMail-search-inp input {height: vw(72); border-radius: vw(36); background: #4d1965; border: 0; padding-left: 40px;  color: #fff;}
  }
</style>